import { inject } from '@angular/core';
import { HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from './authentication.service';
import { CacheService } from '@v2/core/services/cache.service';

export const authHeadersInterceptorFn: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthenticationService);
  const translate = inject(TranslateService);
  const cache = inject(CacheService);

  if (req.url.includes('/sign-in/')) {
    return next(req);
  }

  const language = translate.getCurrentLang() ?? 'en';
  const opId = cache.getOperationId();

  const principal = auth.tryGetPrincipalSnapshot();

  let headers = req.headers;
  headers = addHeaderValue(headers, 'X-Operation-Id', opId);
  headers = addHeaderValue(headers, 'x-language-locale', language);

  if (principal?.activeMember?.identifier != null) {
    headers = addHeaderValue(headers, 'x-active-member', String(principal.activeMember.identifier));
  }

  return next(req.clone({ headers }));
};

function addHeaderValue(httpHeaders: HttpHeaders, name: string, value: string): HttpHeaders {
  if (!httpHeaders.has(name)) {
    httpHeaders = httpHeaders.append(name, value);
  } else if (httpHeaders.get(name) !== value) {
    httpHeaders = httpHeaders.set(name, value);
  }
  return httpHeaders;
}
